import {Navigate, Outlet, useLocation} from 'react-router-dom';
import {PATHS} from 'Routes';
import {useOnboardingSteps} from './useOnboardingSteps';
import {usePath, useReservationSettings} from 'hooks';
import {useAuth} from 'hooks/auth/useAuth';
import {useComputedOnboardingDetails} from 'hooks/useComputedOnboardingDetails';
import {GuestCreationProvider} from 'pages/Auth/context';
import {OnboardingGuestCreationModal} from '../../components/OnboardingGuestCreationModal';
import {ViewLoader} from '../../components/ViewLoader';
import {Container, StyledHeader, StyledOnboardingStepsProgress, Wrapper} from './styled';

function Onboarding() {
  const location = useLocation();

  const {checkCanEditReservationDetails} = useReservationSettings();
  const {steps} = useOnboardingSteps();
  const currentStep = steps.findIndex(step => location.pathname.endsWith(step)) + 1;
  const {areChildrenSameAsRemainingAllowedGuest, isLoadingDetails} =
    useComputedOnboardingDetails();
  const {getFullPath} = usePath();
  const {isLoggedIn, isInitialLoading} = useAuth();

  if (isLoadingDetails || isInitialLoading) {
    return <ViewLoader />;
  }

  if (
    !isLoggedIn ||
    (areChildrenSameAsRemainingAllowedGuest && !checkCanEditReservationDetails())
  ) {
    return <Navigate to={getFullPath(PATHS.home)} replace />;
  }

  return (
    <GuestCreationProvider>
      <Wrapper>
        <StyledHeader onClickLogo={() => {}} />
        <Container>
          {steps.length > 1 && (
            <StyledOnboardingStepsProgress
              totalSteps={steps.length}
              currentStep={currentStep}
            />
          )}
          <Outlet />
        </Container>
        <OnboardingGuestCreationModal />
      </Wrapper>
    </GuestCreationProvider>
  );
}

export {Onboarding};
